import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentDetailClassAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Actions Cell Renderer
 *
 * Renders action menu with document flow button
 *
 * @example
 * ```typescript
 * {
 *   headerName: 'Acciones',
 *   cellRenderer: ActionsCellRendererComponent,
 *   sortable: false,
 *   minWidth: 100,
 *   colId: 'actions'
 * }
 * ```
 */
@Component({
  selector: 'app-actions-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
  ],
  template: `
    <button
      mat-icon-button
      [matMenuTriggerFor]="actionMenu"
      matTooltip="Acciones"
      (click)="$event.stopPropagation()">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actionMenu="matMenu">
       <button mat-menu-item (click)="editMenuItem()">
          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
          <span>Editar Registro</span>
        </button>
        <button mat-menu-item (click)="deleteMenuItem()">
          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
          <span>Eliminar Registro</span>
        </button>
    </mat-menu>
  `,
})
export class ActionsCellRendererComponent implements CellRenderer<DocumentDetailClassAttributes> {
  @Input() params!: CellRendererParams<DocumentDetailClassAttributes>;

  editMenuItem(): void {
    this.params.editMenuItem?.( this.params.data);
  }

  deleteMenuItem(): void {
    this.params.deleteMenuItem?.(this.params.data);
  }
}
